import Vue from "vue";
import VueRouter from "vue-router";
import PageNotFound from '@/pages/PageNotFound'

Vue.use(VueRouter);

let routes = [
  { path: "*", component: PageNotFound }
]

const router = new VueRouter({
  mode:   "history",
  base:   process.env.BASE_URL,
  routes: routes,
});

export default router;
